import {initSlickSlider} from './common';
export default {
    init() {
        initSlickSlider($('.boxer_slider_text'), {
            asNavFor: '.boxer_slider_image',
            arrows: true,
        });

        initSlickSlider($('.boxer_slider_image'), {
            asNavFor: '.boxer_slider_text',
            arrows: true,
        });
       
    },
    finalize() {
        // JavaScript to be fired on the find a retailer page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templatePeugeotBoxer.js